import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import { createStyles, makeStyles, Snackbar } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'

import { Text } from '../components/shared'

const useStyles = makeStyles(
  () =>
    createStyles({
      action: {
        alignItems: 'flex-start'
      }
    }),
  { name: 'OfflineNotification' }
)

type Props = {
  isOffline: boolean
  onClose: () => void
}

const scope = 'views.OfflineNotification'

const OfflineNotification: FC<Props> = ({ isOffline, onClose }) => {
  const s = useStyles()

  return (
    <Snackbar
      open={isOffline}
      autoHideDuration={isOffline ? null : 1000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        variant="filled"
        severity="error"
        onClose={onClose}
        classes={{ action: s.action }}
      >
        <AlertTitle>
          <FormattedMessage
            id={`${scope}.title`}
            defaultMessage="Whoops! No Internet Connection"
          />
        </AlertTitle>
        <Text variant="body2">
          <FormattedMessage
            id={`${scope}.description`}
            defaultMessage="Some parts of this app may be unavailable until you come back online."
          />
        </Text>
      </Alert>
    </Snackbar>
  )
}

export default OfflineNotification
